import React, { memo } from 'react'
import { useFeatureCard, FeatureCardProps } from './useFeatureCard'
import styles from './FeatureCard.module.scss'

const FeatureCard: React.FC<FeatureCardProps> = (props: FeatureCardProps) => {
  const { title, description, icon, isSoon } = useFeatureCard(props)

  return (
    <div className='col-xl-3 col-lg-4 col-6'>
      <div className={`${styles['feature-card']} text-center`}>
        {isSoon && <div className={styles.soon}>Soon</div>}
        <div className={styles['icon-holder']}>
          <i className={`bi bi-${icon}`}></i>
        </div>
        <h4 className={styles['feature-title']}>{title}</h4>
        <p className={styles['feature-description']}>{description}</p>
      </div>
    </div>
  )
}

export default memo(FeatureCard)
